import { BrickContext, ActionBrick, registerBrick } from 'olympe';
import jsonata from 'jsonata';

const extendExpression = (expression) => {
    expression.registerFunction('groupByKey', function (arrayOfObjects, keyName) {
        return arrayOfObjects.reduce((acc, obj) => {
            const key = obj[keyName];
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});
    }, '<as:j>');

    expression.registerFunction('distinctByKey', function (arrayOfObjects, keyName) {
        const keys = new Set();
        return arrayOfObjects.filter(obj => {
            const key = obj[keyName];
            if (keys.has(key)) {
                return false;
            }
            keys.add(key);
            return true;
        });
    }, '<as:j>');
};

export default class JSONAta extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string|*} data
     * @param {string} expression
     * @param {string|*} bindings
     * @param {function()} forwardEvent
     * @param {function(*)} setResult
     */
    async update($, [data, expression, bindings], [forwardEvent, setResult]) {
        try {
            const expr = jsonata(expression);
            extendExpression(expr);
            const jsonData = typeof data === 'string' ? JSON.parse(data) : data;
            const jsonBindings = typeof bindings === 'string' ? JSON.parse(bindings || {}) : bindings;
            const result = await expr.evaluate(jsonData, jsonBindings ?? {});
            setResult(result);
            forwardEvent();
        } catch (error) {
            $.throw(new Error('Failed to evaluate JSONAta: ' + error.message));
            setResult('');
        }

    }
}

registerBrick('01930b3dd1702bf8d6ca', JSONAta);
